import React, { useState, useEffect, useContext } from "react";
import UserDelagateLocationReadOnlyRow from "./UserDelagateLocationReadOnlyRow";
import UserDelegateLocationTableRow from "./UserDelegateLocationTableRow";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";


function UserDelegateLocationTable({ key, setDelegateLocation, loginId, companyId }) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [error, setError] = useState("");
	const [isUserDelegateLocationLoading, setIsUserDelegateLocationLoading] = useState(false);
	const [userDelegateLocations, setUserDelegateLocations] = useState([]);
	const [isUserDelegateLoading, setIsUserDelegateLoading] = useState(false);
	const [userDelegates, setUserDelegates] = useState([]);
	const [count, setCount] = useState(0);
	const closeText = t("page.close");
	const userCtx = useContext(UserContext);

	const initialValues = {
		loginId: loginId,
		companyId: companyId,
		delegateCompanyId: 0,
		appSurveyKey: 0,
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	let userCompanyId = userCtx.userCompanyId;
	useEffect(() => {
		fetchUserDelegates();
		fetchUserDelegateLocations();
	}, []);

	const handleClose = (event) => {
		setDelegateLocation(false);
	};


	function fetchUserDelegates() {
		if (companyId === 0 || !loginId) {
			return;
		}
		resetCounter();
		setIsUserDelegateLoading(false);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web",
				getAll: false,
				companyId: companyId,
				loginId: loginId
			}),
		};
		try {
			FetchUtil.fetchAPI("MGetUserDelegates", "/Service/UserService/GetUserDelegates", requestOptions, getUserDelegatesSuccess, getUserDelegatesFail);
		} catch (error) {
			setIsUserDelegateLoading(false);
			throw new Error(error.message);
		}
	}

	function getUserDelegatesFail(redirect) {
		setIsUserDelegateLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.userDelegateNotRetrieved"));
	}

	function getUserDelegatesSuccess(responseData) {
		let userDelegatesResponse;
		setUserDelegates([]);
		if (responseData) {
			userDelegatesResponse = responseData.getUserDelegatesResponse;
			if (userDelegatesResponse && userDelegatesResponse.errorCode === "0") {
				setUserDelegates([...userDelegatesResponse.delegates]);
			} else if (userDelegatesResponse && userDelegatesResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (userDelegatesResponse) {
				setError(t("error.error") + " " + userDelegatesResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsUserDelegateLoading(false);
	}


	function fetchUserDelegateLocations() {
		setError("");
		if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
			return;
		}
		resetCounter();
		setIsUserDelegateLocationLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: true, companyId: initialValues.companyId,
				loginId: initialValues.loginId, userCompanyId: userCompanyId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetUserDelegateLocation", "/Service/UserService/GetUserDelegateLocation", requestOptions, retrieveDelegateLocationSuccess, retrieveDelegateLocationFail);
		} catch (error) {
			setIsUserDelegateLocationLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveDelegateLocationFail(redirect) {
		setIsUserDelegateLocationLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.delegateGetLocationFailed"));
	}

	function retrieveDelegateLocationSuccess(responseData) {
		let fetchUserDelegateLocationResponse;
		if (responseData) {
			fetchUserDelegateLocationResponse = responseData.getUserDelegateLocationsResponse;
			if (fetchUserDelegateLocationResponse && fetchUserDelegateLocationResponse.errorCode === "0") {
				setUserDelegateLocations(fetchUserDelegateLocationResponse.locations.slice())
			} else if (fetchUserDelegateLocationResponse && fetchUserDelegateLocationResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchUserDelegateLocationResponse) {
				setError(t("error.error") + " " + fetchUserDelegateLocationResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsUserDelegateLocationLoading(false);
	}

	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};

	const addRowTable = () => {
		setError("");
		if (!add) {
			setAdd(true);
		} else {
			setError(t("error.only1RowAllowed"));
		}

	};

	const removeRowTable = () => {
		setError("");
		resetRowTable();
	};
	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleDeleteClick = (event, userDelegateItem, completeCallback) => {
		event.preventDefault();
		deleteUserDelegateLocation(userDelegateItem, completeCallback);
	};
	const deleteUserDelegateLocation = (userDelegateItem, completeCallback) => {
		let action = 3;
		if (userDelegateItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			userDelegateLocationKey: userDelegateItem.userDelegateLocationKey,
			loginId: initialValues.loginId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteUserDelegateLocation", "/Service/UserService/DeleteUserDelegateLocation", requestOptions, deleteDelegateLocationSuccess, deleteDelegateLocationFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deleteDelegateLocationFail(redirect, completeCallback) {
		setError(t("error.userLocEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deleteDelegateLocationSuccess(responseData, completeCallback) {
		let deleteUserDelegateLocationResponse;
		if (responseData) {
			deleteUserDelegateLocationResponse = responseData.deleteUserDelegateLocationResponse;
			if (deleteUserDelegateLocationResponse) {
				if (deleteUserDelegateLocationResponse.errorCode === "0") {
					resetRowTable();
					fetchUserDelegateLocations();
				} else {
					setError(t("error.error") + " " +
						deleteUserDelegateLocationResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}

	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		if (!formValues.loginId) {
			setError(t("error.userReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (userDelegateLocations.length > 0) {
				userDelegateLocations.map((delegateLocationItem, index) => {
					if (delegateLocationItem.locationKey === setValues.locationKey && 
						delegateLocationItem.delegateCompanyId === setValues.delegateCompanyId && 
						delegateLocationItem.userDelegateKey == setValues.userDelegateKey &&
						delegateLocationItem.buyerKey == setValues.buyerKey &&
						delegateLocationItem.indirectBuyerKey == companyId){
						setError(t("error.locDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				saveUserDelegateLocation(action, setValues, completeCallback);
			} else {
				if (completeCallback) {
					completeCallback();
				}
			}
		} else if (completeCallback) {
			completeCallback();
		}
	};
	const saveUserDelegateLocation = (action, setValues, completeCallback) => {
		let serverParams = {
			userDelegateLocationKey: setValues.userDelegateLocationKey,
			loginId: formValues.loginId,
			indirectBuyerKey: formValues.companyId,
			companyId: setValues.delegateCompanyId,
			buyerKey: setValues.buyerKey,
			userDelegateKey: setValues.userDelegateKey,
			level: setValues.level,
			locationKey: setValues.locationKey,
			delegateLocationKey: setValues.delegateLocationKey,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdateUserDelegateLocation", "/Service/UserService/AddUpdateUserDelegateLocation", requestOptions, saveDelegateLocationSuccess, saveDelegateLocationFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveDelegateLocationFail(redirect, completeCallback) {
		setError(t("error.userLocEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveDelegateLocationSuccess(responseData, completeCallback) {
		let addUpdateUserDelegateLocationResponse;
		if (responseData) {
			addUpdateUserDelegateLocationResponse = responseData.addUpdateUserDelegateLocationResponse;
			if (addUpdateUserDelegateLocationResponse) {
				if (addUpdateUserDelegateLocationResponse.errorCode === "0") {
					resetRowTable();
					fetchUserDelegateLocations();
				} else {
					setError(t("error.error") + " " +
						addUpdateUserDelegateLocationResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="container-fluid container_list_sm viewh-85">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
						{( isUserDelegateLocationLoading || isUserDelegateLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<table className="list-table" role="table">
								<thead>
									<tr role="row">
										<th className="list-th">{t("header.admin.delegate")}</th>
										<th className="list-th">{t("page.loc.name")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</thead>
								<tbody role="rowgroup">
									{add && addRowTop &&
										<UserDelegateLocationTableRow
											index={count}
											userDelegates={userDelegates}
											companyId={companyId}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((userDelegateLocations.length % 2) > 0) ? true : false} />
									}
									{(userDelegateLocations.length > 0) ? (
										userDelegateLocations.map((delegateLocationItem, index) => (
											<UserDelagateLocationReadOnlyRow
												index={count}
												t={t}
												delegateLocationItem={delegateLocationItem}
												handleDeleteClick={handleDeleteClick}
												oddIdx={((index % 2) > 0) ? true : false}
												setError={setError}
												handleSubmit={handleSubmit}
											/>
										))
									) : (<></>)}
									{add && addRowBottom &&
										<UserDelegateLocationTableRow
											index={count}
											userDelegates={userDelegates}
											companyId={companyId}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((userDelegateLocations.length % 2) > 0) ? true : false} />
									}
								</tbody>
								{(userDelegateLocations.length > 10) ? (<tfoot>
									<tr role="row">
										<th className="list-th">{t("header.admin.delegate")}</th>
										<th className="list-th">{t("page.loc.name")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</tfoot>
								) : (<></>)}
							</table>
							<div className="row">
								<div className="col mt-3">
									{(error) ? (
										<div id="inerrorMessage1" className="errorblock">
											{error}
										</div>
									) : (<></>)}
								</div>
							</div>
							<div className="footer">
								<input
									type="button"
									name="edit-sub-appsurvey-close"
									id="edit-sub-appsurvey-close"
									className="btn btn-secondary btn-block" data-dismiss="modal"
									onClick={(e) => handleClose(e)}
									style={{ marginTop: "10px", marginBottom: "10px" }}
									value={closeText}
								></input>
							</div>
						</div>
					</div>
				</div>
				: null}
		</>
	);
}
export default UserDelegateLocationTable;